// property name with these prefix need to be removed when searching DOM
const propertyPrefix = ["icontent_", "ichangetrackable_", "iversionable_", "iroutable_"];

const selector = (propertyName: string): string => {
    propertyPrefix.forEach(function (prefix) {
        if (propertyName.indexOf(prefix) === 0) {
            propertyName = propertyName.substring(prefix.length);
        }
    });

    return "[data-epi-property-name='" + propertyName + "' i], [data-epi-edit='" + propertyName + "' i]";
};

const filterNestedNodes = (nodes: NodeListOf<Element>): HTMLElement[] => {
    const result: HTMLElement[] = [];
    nodes.forEach((x) => {
        const htmlEl = x as HTMLElement;
        if (htmlEl.parentElement && htmlEl.parentElement.closest("[data-epi-property-name],[data-epi-edit]")) {
            return;
        }
        result.push(htmlEl);
    });
    return result;
};

export const loadPropertiesFromElement = (container: ParentNode, propertyName: string): HTMLElement[] => {
    return filterNestedNodes(container.querySelectorAll(selector(propertyName)));
};

export const tryGetBlockElement = (container: ParentNode, blockId: string): HTMLElement | null => {
    if (!blockId) {
        return null;
    }

    const contentLinkParts = blockId.split("_");
    const id = contentLinkParts[0];
    const blockNode = container.querySelector(`[data-epi-block-id="${id}"]`);
    if (blockNode) {
        return blockNode as HTMLElement;
    }

    return container.querySelector(`[data-epi-block-id^="${id}_"]`);
};
